export default __webpack_public_path__ + "e080fbd0716f576dd6f359a10ef68ce6.png";